import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import { desoLoginSuccess, twitterSignOut } from "../../reducers/auth/action";
import checkMark from "../../images/Svg/navbar/checkmark.svg";
import unCheckMark from "../../images/Svg/navbar/uncheckmark.svg";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

export default function NavbarDropdown({
  desoLogin,
  mobile,
  username,
  handleChange,
  status,
  setStatus,
}) {
  const { deso } = useSelector((state) => state?.auth);

  const dispatch = useDispatch();

  const handleLogout = () => {
    pushGaEvent(gaEvents.NAVBAR_LOGUT_BUTTON_CLICKED);
    localStorage.clear();
    sessionStorage.clear();
    dispatch(desoLoginSuccess(null));
    dispatch(twitterSignOut());
  };
  const changeAceount = () => {
    pushGaEvent(gaEvents.CHANGE_ACCOUNT_BUTTON_CLICKED);
    desoLogin();
  };
  return (
    <div
      className={`${
        mobile
          ? "w-[200px] border border-[#5463FF] top-14 z-10 right-6 tooltip"
          : "w-[265px] border-[#E1E1E1] right-0 top-12"
      } absolute block text-left bg-white rounded-[4px] shadow-md z-[1002]`}
    >
      {mobile ? (
        <div>
          <h6 className="text-[#000000] text-[14px] font-bold p-[12px]">
            Your DeSo Account
          </h6>
          <hr className="text-[#E1E1E1]" />
          <div className="flex items-center p-[12px]">
            <img
              className="h-[32px] w-[32px] text-center mr-2"
              src={`https://web3setu.co.in/tweets/get-user-profile-image/${deso?.user?.publicKeyAdded}`}
            />
            <p>
              {username
                ? username.length > 9
                  ? username.slice(0, 9).concat("..")
                  : username
                : deso?.user?.publicKeyAdded?.slice(0, 10).concat("..")}
            </p>
          </div>

          <div className="px-[16px] mb-[16px]" onClick={handleChange}>
            <div className="flex items-center justify-between">
              <h1 className="text-[#161616] py-1 text-[16px] cursor-pointer">
                Setu Signature
              </h1>
              <img src={status ? checkMark : unCheckMark} alt="" />
            </div>
            <p className="text-[#585858] text-[14px]">
              Posted via @setu_deso signature will be removed when disabled
            </p>
          </div>

          <p
            onClick={changeAceount}
            className="text-[#161616] pl-[16px] text-[16px] cursor-pointer hover:bg-[#5463FF] hover:text-white hover:rounded-[4px] h-[44px] flex items-center"
          >
            Change account
          </p>
          <p
            onClick={handleLogout}
            className="text-[#161616] pl-[16px] rounded-[4px] text-[16px] cursor-pointer hover:bg-[#5463FF] hover:text-white bg-[#F4F5FD] h-[44px] flex items-center"
          >
            Logout
          </p>
        </div>
      ) : (
        <>
          <div
            className="px-[16px] my-[16px] cursor-pointer"
            onClick={handleChange}
          >
            <div className="flex items-center justify-between">
              <p className="text-[#161616] py-1 text-[16px] cursor-pointer">
                Setu Signature
              </p>
              <img src={status ? checkMark : unCheckMark} alt="" />
            </div>
            <p className="text-[#585858] text-[14px]">
              Posted via @setu_deso signature will be removed when disabled
            </p>
          </div>
          <p
            onClick={changeAceount}
            className="text-[#161616] py-1 pl-[16px] text-[16px] cursor-pointer hover:bg-[#F4F5FD] hover:rounded-[4px] h-[40px] flex items-center"
          >
            Change account
          </p>
          <p
            onClick={handleLogout}
            className="text-[#161616] py-1 pl-[16px] rounded-[4px] text-[16px] cursor-pointer hover:bg-[#F4F5FD] h-[40px] flex items-center"
          >
            Logout
          </p>
        </>
      )}
    </div>
  );
}
